exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".whs-hotel-stars[data-v-b07da17e]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.whs-hotel-star[data-v-b07da17e]:before{content:\"\\F005\";color:var(--color-third);font-size:inherit;margin-right:2px}", ""]);

// exports
